import CohortLevelBar from "./CohortLevelBar";

const stripCohortCode = (title = "") => title.replace(/\s*\(C\d+\)\s*$/i, "");

const CohortLevelBarSection = ({ categories, showCohortMetric = true }) => {
  const levels = categories.map(({ id, title, count, icon, className }) => ({
    id,
    label: stripCohortCode(title),
    count,
    icon,
    className,
  }));

  return <CohortLevelBar levels={levels} showCohortMetric={showCohortMetric} />;
};

export default CohortLevelBarSection;
